import { render, staticRenderFns } from "./UsersItem.vue?vue&type=template&id=81b4b708&lang=pug&"
import script from "./UsersItem.vue?vue&type=script&lang=js&"
export * from "./UsersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports